<template>
  <UICard title="Analytics decimal precisions">
    <UIInputSelect v-model="value" :data />
  </UICard>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import { useSettingsStore } from '@/store/settings'

import { UICard } from '@ui/core'
import { UIInputSelect } from '@ui/fields'

const settingsStore = useSettingsStore()

const data = Array.from({ length: 7 }, (_, i) => ({
  value: `${i}`,
  label: `${i} digits`,
}))

const value = computed({
  get() {
    return settingsStore.getAnalyticsDecimalPrecisions.toString()
  },
  set(value) {
    settingsStore.setAnalyticsDecimalPrecisions(+value)
  },
})
</script>
